import { Button } from "@rio-cloud/rio-uikit";
import { IOccurrenceVehicleData } from "../../../api/fetchOccurence"
import { useIntl } from "react-intl";

interface Props {
    occurrenceVehicleData: IOccurrenceVehicleData;
    onClear?: null | VoidFunction;
}

const MainOccurenceCard = ({ occurrenceVehicleData, onClear }: Props) => {
    const intl = useIntl();

    return (
        <div className="w-full mb-10 rounded-lg border border-gray-200 bg-white px-5 py-4 flex items-center justify-between shadow-sm">
            <div className="flex items-center gap-4">
                <div>
                    <p className="text-2lg font-bold">
                        {occurrenceVehicleData?.model}
                    </p>

                    <p className="text-2lg">
                        Chassi - {occurrenceVehicleData?.chassis}
                    </p>
                </div>
            </div>
            <div className="flex items-center gap-25">
                <div className="flex items-center gap-3">
                    <p className="text-2lg font-bold">Contrato</p>
                    <p className="text-2lg font-bold">-</p>
                    <p className="text-2lg font-bold">
                        {occurrenceVehicleData?.contractNumber || 'N/A'}
                    </p>
                </div>

                <div className="flex items-center gap-3">
                    <p className="text-2lg font-bold">Ocorrência</p>
                    <p className="text-2lg font-bold">-</p>
                    <p className="text-2lg font-bold">
                        {occurrenceVehicleData?.protocolNumber || 'N/A'}
                    </p>
                </div>

                {onClear ? (
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            aria-label={intl.formatMessage({ id: "intl-msg:tas.occurrence.unlink-occurrence" })}
                            title={intl.formatMessage({ id: "intl-msg:tas.occurrence.unlink-occurrence" })}
                            className="btn btn-link padding-0 text-color-gray"
                            onClick={onClear}
                        >
                            <span className="rioglyph rioglyph-remove-sign margin-0" />
                        </button>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default MainOccurenceCard;